module.exports = __webpack_public_path__ + "img/villa_dialog_icon01.3c6bda0f.png";